import React from "react";
import { useNavigate } from "react-router-dom";

const colors = {
  brand: "#6D9BC3",
  text: "#2b2d42",
  muted: "#8d99ae",
  white: "#ffffff"
};

function NotFound() {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.code}>404</div>
        <div style={styles.title}>Location Unavailable</div>

        <div style={styles.desc}>
          The requested system resource could not be located or the access path has been modified.
        </div>

        <button style={styles.button} onClick={() => navigate("/")}>
          Return to Dashboard
        </button>
      </div>
    </div>
  );
}

/* ---------- STYLES ---------- */

const styles = {
  container: {
    minHeight: "70vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "sans-serif"
  },
  card: {
    textAlign: "center",
    padding: "40px",
    maxWidth: "400px"
  },
  code: {
    fontSize: "72px",
    fontWeight: "800",
    color: colors.brand,
    marginBottom: "10px",
    letterSpacing: "-2px"
  },
  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: colors.text,
    marginBottom: "15px",
    textTransform: "uppercase"
  },
  desc: {
    color: colors.muted,
    lineHeight: "1.6",
    fontSize: "14px",
    marginBottom: "30px",
  },
  button: {
    padding: "12px 24px",
    border: "none",
    borderRadius: "8px",
    background: colors.brand,
    color: colors.white,
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "14px",
    transition: "opacity 0.2s ease"
  }
};

export default NotFound;